export const ADD_MESSAGE = 'ADD_MESSAGE';
export const USER_CONFIRMATION = 'USER_CONFIRMATION';
export const BARGAIN_LOADING = 'BARGAIN_LOADING';
export const BARGAIN_DATA = 'BARGAIN_DATA';
export const SET_FINAL_PRICE = 'SET_FINAL_PRICE';
export const SET_FINISH_BARGAIN = 'SET_FINISH_BARGAIN';
export const SET_USER_ATTEMPT = 'SET_USER_ATTEMPT';
export const SET_BARGAIN_VALUE = 'SET_BARGAIN_VALUE';
export const CLEAR_BARGAIN = 'CLEAR_BARGAIN';
